import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouseScrollDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMouseScrollDown"><Path fillRule="evenodd" clipRule="evenodd" d="M8.79199 19.2099L12 21.3486L15.208 19.2099L16.0401 20.458L12 23.1514L7.95994 20.458L8.79199 19.2099Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M6 7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12V7ZM12.75 5H11.25V9H12.75V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMouseScrollDown;
